// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanSetProps } from "./hook";

export type CanSetPropsProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanSetProps({ children, fallback, scope }: CanSetPropsProps) {
  const canDoAction = useCanSetProps(scope);
  return <>{canDoAction ? children : fallback}</>;
}
